import { Check } from 'lucide-react';
import type { InviteResolution } from '../api/captureApi';
import styles from './CapturePagePrimitives.module.css';

export function PracticeHeader({ resolution }: { resolution: InviteResolution }) {
  const initials = resolution.practiceName
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');

  return (
    <div className={styles.header}>
      {resolution.logoUrl ? (
        <img
          src={resolution.logoUrl}
          alt={resolution.practiceName}
          className={`${styles.logo}${resolution.logoOnDark ? ` ${styles.logoDark}` : ''}`}
        />
      ) : (
        <div className={styles.logoInitials}>{initials}</div>
      )}
      <div>
        <div className={styles.practiceName}>{resolution.practiceName}</div>
        {resolution.locationCity && (
          <div className={styles.practiceCity}>{resolution.locationCity}</div>
        )}
      </div>
    </div>
  );
}

export function OptionBtn({
  label,
  sublabel,
  selected,
  onClick,
  disabled,
}: {
  label: string;
  sublabel?: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`${styles.option} ${selected ? styles.optionSelected : ''} ${disabled ? styles.optionDisabled : ''}`}
      onClick={onClick}
    >
      {selected && <Check size={14} className={styles.optionCheck} aria-hidden />}
      {sublabel ? (
        <span className={styles.optionTextGroup}>
          <span>{label}</span>
          <span className={styles.optionSublabel}>{sublabel}</span>
        </span>
      ) : (
        label
      )}
    </button>
  );
}

export function StarPicker({
  value,
  onChange,
}: {
  value: number | null;
  onChange: (n: number) => void;
}) {
  return (
    <div className={styles.starPicker} role="group" aria-label="Star rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          className={`${styles.starBtn} ${value !== null && n <= value ? styles.starBtnFilled : ''}`}
          onClick={() => onChange(n)}
          aria-label={`${n} star${n > 1 ? 's' : ''}`}
        >
          ★
        </button>
      ))}
    </div>
  );
}
